// EIP-1193 provider error codes, plus the JSON-RPC internal error.
export enum ChainCodeErrorEnum {
  UNAVAILABLE = 4902, // chain has not been added to MetaMask
  CANCELLED = 4001, // switching chain has been cancelled
  /**
   * The wallet will not act for this ACCOUNT -- not the user clicking reject,
   * which is 4001/CANCELLED. EIP-1193 defines it as "the requested method
   * and/or account has not been authorized by the user" and recommends it
   * "in case of authorization failures".
   *
   * When we saw it, the app was asking the wrong wallet: registration took
   * web3-react's priority connector rather than the wallet the user selected,
   * and signed as account #0 of whatever answered. Both halves are fixed (see
   * useRegister and utils/signing.ts), so a 4100 reaching a user now means the
   * wallet genuinely has not granted the account we asked for -- which is worth
   * saying plainly rather than advising a retry that cannot succeed.
   */
  UNAUTHORIZED = 4100,
  /**
   * JSON-RPC "Internal error", NOT a user denial -- the name and the old comment
   * both misread it. Wallets do return it when a user dismisses some prompts,
   * which is why useRetrieve treats it that way, but it also covers genuine
   * internal failures, so it is not safe to report as "you cancelled". Left as-is
   * because retyping the meaning is a behaviour change on a live path; recorded
   * here so the next reader is not misled the way this comment misled us.
   */
  DENIED = -32603,
}
